import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReplaceVersionMetadataMutationVariables = Types.Exact<{
  input: Types.ReplaceVersionMetadataInput;
}>;


export type ReplaceVersionMetadataMutation = { __typename?: 'Mutation', replaceVersionMetadata: { __typename?: 'ReplaceVersionMetadataPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string, keywordAssignments?: Array<{ __typename?: 'KeywordAssignment', keyword: { __typename?: 'Keyword', id: string, name: string }, vexClusterAssignments: Array<{ __typename?: 'VexClusterAssignment', vexCluster: { __typename?: 'VexCluster', id: string, name: string } }> }> | null }> } | null } };

export type AppendVersionMetadataMutationVariables = Types.Exact<{
  input: Types.AppendVersionMetadataInput;
}>;


export type AppendVersionMetadataMutation = { __typename?: 'Mutation', appendVersionMetadata: { __typename?: 'AppendVersionMetadataPayload', regulatoryDocument?: { __typename?: 'RegulatoryDocument', id: string, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', id: string, keywordAssignments?: Array<{ __typename?: 'KeywordAssignment', keyword: { __typename?: 'Keyword', id: string, name: string }, vexClusterAssignments: Array<{ __typename?: 'VexClusterAssignment', vexCluster: { __typename?: 'VexCluster', id: string, name: string } }> }> | null }> } | null } };


export const ReplaceVersionMetadataDocument = gql`
    mutation ReplaceVersionMetadata($input: ReplaceVersionMetadataInput!) {
  replaceVersionMetadata(input: $input) {
    regulatoryDocument {
      id
      paragraphs {
        id
        keywordAssignments {
          keyword {
            id
            name
          }
          vexClusterAssignments {
            vexCluster {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export type ReplaceVersionMetadataMutationFn = Apollo.MutationFunction<ReplaceVersionMetadataMutation, ReplaceVersionMetadataMutationVariables>;

/**
 * __useReplaceVersionMetadataMutation__
 *
 * To run a mutation, you first call `useReplaceVersionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceVersionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceVersionMetadataMutation, { data, loading, error }] = useReplaceVersionMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceVersionMetadataMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceVersionMetadataMutation, ReplaceVersionMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceVersionMetadataMutation, ReplaceVersionMetadataMutationVariables>(ReplaceVersionMetadataDocument, options);
      }
export type ReplaceVersionMetadataMutationHookResult = ReturnType<typeof useReplaceVersionMetadataMutation>;
export type ReplaceVersionMetadataMutationResult = Apollo.MutationResult<ReplaceVersionMetadataMutation>;
export type ReplaceVersionMetadataMutationOptions = Apollo.BaseMutationOptions<ReplaceVersionMetadataMutation, ReplaceVersionMetadataMutationVariables>;
export const AppendVersionMetadataDocument = gql`
    mutation AppendVersionMetadata($input: AppendVersionMetadataInput!) {
  appendVersionMetadata(input: $input) {
    regulatoryDocument {
      id
      paragraphs {
        id
        keywordAssignments {
          keyword {
            id
            name
          }
          vexClusterAssignments {
            vexCluster {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export type AppendVersionMetadataMutationFn = Apollo.MutationFunction<AppendVersionMetadataMutation, AppendVersionMetadataMutationVariables>;

/**
 * __useAppendVersionMetadataMutation__
 *
 * To run a mutation, you first call `useAppendVersionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppendVersionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appendVersionMetadataMutation, { data, loading, error }] = useAppendVersionMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppendVersionMetadataMutation(baseOptions?: Apollo.MutationHookOptions<AppendVersionMetadataMutation, AppendVersionMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppendVersionMetadataMutation, AppendVersionMetadataMutationVariables>(AppendVersionMetadataDocument, options);
      }
export type AppendVersionMetadataMutationHookResult = ReturnType<typeof useAppendVersionMetadataMutation>;
export type AppendVersionMetadataMutationResult = Apollo.MutationResult<AppendVersionMetadataMutation>;
export type AppendVersionMetadataMutationOptions = Apollo.BaseMutationOptions<AppendVersionMetadataMutation, AppendVersionMetadataMutationVariables>;